import React, { useCallback, useEffect } from "react";
import WebLayout from "../../../layout/WebLayout";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import OrderAction from "../../../stores/actions/OrderAction";
import { RootState } from "../../../stores";
import moment from "moment";
import { Margin, usePDF } from "react-to-pdf";
import ReactToPrint from "react-to-print";
import { LOGO } from "../../../utils/Constants";
import { CANCELLED } from "../../../utils/Constants";

function BuyerInvoice() {
  const { toPDF, targetRef } = usePDF({
    filename: ".pdf",
    page: { margin: Margin.MEDIUM },
  });

  let subTotal = 0;
  let gross = 0;
  let grandTotal = 0;
  const routeParams = useParams();
  const id = routeParams.id;

  const dispatch = useDispatch<any>();
  const { buyerInvoice } = useSelector((state: RootState) => state.order);

  const getOrderDetails = useCallback(async () => {
    await dispatch(
      OrderAction.getBuyerInvoice({
        id: id,
      })
    );
  }, [dispatch, id]);

  useEffect(() => {
    getOrderDetails();
  }, [getOrderDetails]);
  return (
    <WebLayout pageName={"BuyerInvoice"}>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <div className="row invoice-preview g-2">
            <div className="col-xl-12 col-md-8 col-12 mb-md-0 mb-2">
              <div
                className="card invoice-preview-card"
                ref={targetRef}
                id="print_invoice">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center flex-xl-row flex-md-column flex-sm-row flex-column p-0">
                    <div className="mb-xl-0 mb-2">
                      <div className="d-flex svg-illustration gap-2">
                        <span className="app-brand-text demo text-body fw-bold">
                          <img src={LOGO} height={80} />
                        </span>
                      </div>
                    </div>
                    <div className="mt-1">
                      <h4 className="mb-2">
                        Invoice No. #{buyerInvoice.order_generate_id}
                      </h4>
                      <div className="mb-2">
                        <span className="me-1">Invoice Date:</span>
                        <span className="fw-medium">
                          {moment(buyerInvoice?.invoiceDate).format("lll")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="my-0" />
                <div className="card-body">
                  <div className="d-flex justify-content-between">
                    <div>
                      <h6 className="pb-0 mb-2">Invoice From:</h6>
                      <p className="mb-1">
                        <b>
                          {buyerInvoice?.ddb_details?.name_of_entity || "NA"}(
                          {buyerInvoice?.ddb_details?.code || "NA"})
                        </b>
                      </p>
                      <p className="mb-1">
                        <b>Address</b>{" "}
                        {buyerInvoice?.ddb_details?.address || "NA"}
                      </p>
                      <p className="mb-1">
                        <b>Mobile No.</b>{" "}
                        {buyerInvoice?.ddb_details?.mobile || "NA"}
                      </p>
                      <p className="mb-0">
                        <b>Email</b> {buyerInvoice?.ddb_details?.email || "NA"}
                      </p>
                      <p className="mb-0">
                        <b>GST</b> {buyerInvoice?.ddb_details?.gst_no || "NA"}
                      </p>
                    </div>
                    <div>
                      <h6 className="pb-0 mb-2">Invoice To:</h6>
                      <p className="mb-1">
                        <b>
                          {buyerInvoice.name_of_entity || "NA"} (
                          {buyerInvoice.account_id || "NA"})
                        </b>
                      </p>
                      <p className="mb-1">
                        <b>Address</b> {buyerInvoice.address || "NA"}
                      </p>
                      <p className="mb-1">
                        <b>Mobile No.</b> {buyerInvoice.mobile || "NA"}
                      </p>
                      <p className="mb-0">
                        <b>Email</b> {buyerInvoice.email || "NA"}
                      </p>
                      <p className="mb-0">
                        <b>GST</b> {buyerInvoice.gst_no || "NA"}
                      </p>
                    </div>
                  </div>
                </div>
                {buyerInvoice.order_status === "CANCELLED_BY_USER" ? (
                  <div className="cancle_watermark">
                    <img src={CANCELLED} alt="" width={"100%"} />
                  </div>
                ) : (
                  ""
                )}

                <div className="table-responsive">
                  <table className="table border-top m-0">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Item</th>
                        <th>HSN Code</th>
                        <th>Unit Price</th>
                        <th>Qty</th>
                        <th>Taxable Value</th>
                        <th>Tax Rate(%)</th>
                        <th>Tax Value</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {buyerInvoice.items &&
                        buyerInvoice.items.map((order: any, index: number) => {
                          subTotal += order.rowTotalAmount;
                          grandTotal =
                            Number(subTotal) +
                            Number(buyerInvoice.delivery_charge);
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{order.product_name}</td>
                              <td>{order.hsn_code}</td>
                              <td>{order.sell_price}</td>
                              <td>{order.dispatch_qty}</td>
                              <td>{order.rowTotalTaxableValue.toFixed(2)}</td>
                              <td>{order.taxRate}</td>
                              <td>{order.rowTotalTax.toFixed(2)}</td>
                              <td>{order.rowTotalAmount.toFixed(2)}</td>
                            </tr>
                          );
                        })}
                      {/* <tr>
                        <th colSpan={2} className="align-top px-4 py-2"></th>
                        <th className="text-end px-4 py-2">Tax %</th>
                        <th className="text-end px-4 py-2">Qty</th>
                        <th className="text-end px-4 py-2">Taxable Amt.</th>
                        <th className="text-end px-4 py-2">CGST</th>
                        <th className="text-end px-4 py-2">SGST</th>
                        <th className="text-end px-4 py-2">IGST</th>
                        <th className="text-end px-4 py-2">Total Amt.</th>
                      </tr>
                      <tr>
                        <td colSpan={2} className="align-top px-4 py-2"></td>
                        <td className="text-end px-4 py-2">5</td>
                        <td className="text-end px-4 py-2">2</td>
                        <td className="text-end px-4 py-2">1998.10</td>
                        <td className="text-end px-4 py-2">-</td>
                        <td className="text-end px-4 py-2">-</td>
                        <td className="text-end px-4 py-2">-</td>
                        <td className="text-end px-4 py-2">21397.96</td>
                      </tr> */}
                      {/* <tr>
                        <td colSpan={7} className="align-top px-4 py-2"></td>
                        <td className="text-end px-4 py-2">
                          <p className="mb-0">Sub Total:</p>
                        </td>
                        <td className="px-4 py-2">
                          <p className="fw-medium mb-2">
                            {subTotal.toFixed(2)}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={7} className="align-top px-4 py-2"></td>
                        <td className="text-end px-4 py-2">
                          <p className="mb-0">Delivery Charge:</p>
                        </td>
                        <td className="px-4 py-2">
                          <p className="fw-medium mb-2">
                            {buyerInvoice.delivery_charge}
                          </p>
                        </td>
                      </tr> */}
                      <tr>
                        <td colSpan={7} className="align-top px-4 py-2"></td>
                        <td className="text-end px-4 py-2">
                          <p className="mb-0">Grand Total:</p>
                        </td>
                        <td className="px-4 py-2">
                          <p className="fw-medium mb-2">
                            {grandTotal.toFixed(2)}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={12} className="align-top px-4 py-2">
                          <span className="fw-medium">Declaration: </span>
                          <span>
                            We Declare that this invoice shows the actual price
                            of the goods described and that all particulars are
                            true and correct.
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-xl-2 col-md-4 col-12 invoice-actions">
              <div className="card-body p-3 d-flex">
                <button
                  onClick={() => toPDF()}
                  className="btn btn-primary d-grid w-100 mb-3"
                  style={{ marginRight: "20px" }}>
                  Download
                </button>

                <ReactToPrint
                  trigger={() => {
                    return (
                      <button className="btn btn-primary d-grid w-100 mb-3">
                        Print
                      </button>
                    );
                  }}
                  content={() => targetRef.current}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default BuyerInvoice;
